export const Home ='/';
export const About = '/about';
export const Product = '/product';
export const ContactUs = '/contact';
export const AssetLinks = '/.well-known/';
export const PrivacyPolicy = '/privacy-policy/';
export const TermsConditions = '/terms-conditions/';